import Vue from 'vue';
import Router from 'vue-router';
import FlightManager from './views/FlightManager.vue';
import EditGate from './components/gate/EditGate.vue';
import EditClaim from './components/claim/EditClaim.vue';
import EditStatus from './components/status/EditStatus.vue';
import Login from './components/Login.vue';
import Register from './components/Register.vue';
import ManageUsers from './views/ManageUsers.vue';
import ManageRole from './views/ManageRoles.vue';
import UserProfile from './views/UserProfile.vue';
import Report from './views/Report.vue';
import EditUser from './components/user/EditUser.vue';
import EditUserRole from './components/role/EditUserRole.vue';
import { routeNames } from './js/routeNames';
import i18n, { loadLocaleMessagesAsync } from './i18n';
import {
  setDocumentDirectionPerLocale,
  setDocumentLang,
  setDocumentTitle,
} from './js/utils/i18n/document.js';
import Root from './Root.vue';
import { decryptData } from './js/utils/encrypt';
import ManageGates from './views/ManageGates.vue';
import ManageClaims from './views/ManageClaims.vue';
import ManageFlightStatus from './views/ManageFlightStatus.vue';
import ManageCheckinRows from './views/ManageCheckinRows.vue';
import ManageAirline from './components/airline/ManageAirline.vue';
import EditAirline from './components/airline/EditAirline.vue';
import EditCheckinRow from './components/checkin/EditCheckinRow.vue';
import Operator from './views/Operator.vue';

Vue.use(Router);

const { locale } = i18n;

//Decrypting Permissions
let mkLocalData = localStorage.getItem('Permissions');
if (!mkLocalData) {
  mkLocalData = 'null';
}
const secretPermissionKey = process.env.KEY || 'myscecretkey';
var permissions = decryptData(mkLocalData, secretPermissionKey);
let authLocalData = localStorage.getItem('Login');
if (!authLocalData) {
  authLocalData = 'null';
}
var isAuthenticated = decryptData(authLocalData, secretPermissionKey);

var isSuperAdminConfigured = localStorage.getItem('isSuperAdminConfigured');
// var registered = localStorage.getItem('registered');

const routes = [
  {
    path: '/',
    redirect: locale,
  },
  {
    path: '/:locale',
    component: Root,
    children: [
      {
        path: '/:locale/userprofile',
        name: routeNames.userProfile,
        component: UserProfile,
      },
      {
        path: '/:locale/report',
        name: routeNames.report,
        component: Report,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-Audit'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        },
        
      },
      {
        path: '/:locale/flightmanager',
        name: routeNames.flightManager,
        component: FlightManager,
      },
      {
        path: '/:locale/operator',
        name: routeNames.operator,
        component: Operator,
        beforeEnter: (to, from, next) => {
          const hasAccess = permissions.includes('View-Gate') || permissions.includes('View-Claim') || permissions.includes('Gate-Operator') || permissions.includes('Claim-Operator');
          if (!hasAccess)
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/managecheckinrows',
        name: routeNames.manageCheckinRow,
        component: ManageCheckinRows,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-CheckinRow'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/managegates',
        name: routeNames.manageGate,
        component: ManageGates,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-Gate'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/manageclaims',
        name: routeNames.manageClaim,
        component: ManageClaims,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-Claim'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/managestatus',
        name: routeNames.manageStatus,
        component: ManageFlightStatus,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-Status'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/manageairline',
        name: routeNames.manageAirline,
        component: ManageAirline,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('View-Airline'))
            next({ path: locale + '/flightmanager' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/newcheckinrow',
        name: routeNames.newCheckinRow,
        component: EditCheckinRow,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-CheckinRow'))
            next({ path: locale + '/managecheckinrows' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/editcheckinrow/:id',
        name: routeNames.editCheckinRow,
        component: EditCheckinRow,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-CheckinRow'))
            next({ path: locale + '/managecheckinrows' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/editgates/:editid',
        name: routeNames.editGate,
        component: EditGate,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-Gate'))
            next({ path: locale + '/managegates' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/editclaims/:editid',
        name: routeNames.editClaim,
        component: EditClaim,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-Gate'))
            next({ path: locale + '/manageclaims' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/editstatus/:editid',
        name: routeNames.editStatus,
        component: EditStatus,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-Status'))
            next({ path: locale + '/managestatus' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/editairline/:code_type/:code',
        name: routeNames.editAirline,
        component: EditAirline,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-Airline'))
            next({ path: locale + '/manageairline' });
          else {
            next();
          }
        }
      },
      {
        path: '/:locale/newgate',
        name: routeNames.newGate,
        component: EditGate,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-Gate'))
            next({ path: locale + '/managegates' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/newairline',
        name: routeNames.newAirline,
        component: EditAirline,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-Airline'))
            next({ path: locale + '/manageairline' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/newclaim',
        name: routeNames.newClaim,
        component: EditClaim,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-Gate'))
            next({ path: locale + '/manageclaims' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/newstatus',
        name: routeNames.newStatus,
        component: EditStatus,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-Status'))
            next({ path: locale + '/managestatus' });
          else {
            next();
          }
        },
      },
      {

        path: '/:locale/',
        name: routeNames.login,
        component: Login,
        beforeEnter: (to, from, next) => {
          if (isAuthenticated==true){
            next({ path: locale + '/flightmanager' });
          }
          else{
            next();
          }
        },
      },
      {
        path: '/:locale/register',
        name: routeNames.register,
        component: Register,
        beforeEnter: (to, from, next) => {
          if (isSuperAdminConfigured == 'yesadmin')
            next({ path: locale + '/' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/manageuser',
        name: routeNames.manageUser,
        component: ManageUsers,
      },
      {
        path: '/:locale/manageroles',
        name: routeNames.manageRole,
        component: ManageRole,
      },
      {
        path: '/:locale/edituser/:userid',
        name: routeNames.editUser,
        component: EditUser,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-User'))
            next({ path: locale + '/manageuser' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/newroles',
        name: routeNames.newUserRole,
        component: EditUserRole,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-Role'))
            next({ path: locale + '/manageroles' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/editroles/:roleid',
        name: routeNames.editUserRole,
        component: EditUserRole,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Edit-Role'))
            next({ path: locale + '/manageroles' });
          else {
            next();
          }
        },
      },
      {
        path: '/:locale/newuser',
        name: routeNames.newUser,
        component: EditUser,
        beforeEnter: (to, from, next) => {
          if (!permissions.includes('Create-User'))
            next({ path: locale + '/manageuser' });
          else {
            next();
          }
        },
      },
    ],
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let mkLocalData = localStorage.getItem('Login');
  if (!mkLocalData) {
    mkLocalData = 'null';
  }
  const secretKey = process.env.KEY || 'myscecretkey';
  var isAuthenticated = decryptData(mkLocalData, secretKey);

  if (
    to.name !== routeNames.login &&
    to.name !== routeNames.register &&
    !isAuthenticated
  )
    next({ name: routeNames.login });
  else next();
});

function applyDocumentTitle() {
  setDocumentTitle(i18n.t('app.title'));
}

router.beforeEach((to, from, next) => {
  if (to.params.locale === from.params.locale) {
    applyDocumentTitle();
    next();
    return;
  }

  const { locale } = to.params;

  loadLocaleMessagesAsync(locale).then(() => {
    localStorage.setItem('lang', JSON.stringify(locale));

    setDocumentLang(locale);

    setDocumentDirectionPerLocale(locale);

    applyDocumentTitle();
  });

  next();
});

export default router;
